import type { Attachment } from 'svelte/attachments'
import { prefersReducedMotion } from './motion'

/**
 * Jolts the element once every time the parameter turns truthy.
 * Usage: `{@attach shake(impact)}`.
 */
export const shake =
  (active: boolean): Attachment<HTMLElement> =>
  (node) => {
    if (!active || prefersReducedMotion()) return

    const animation = node.animate(
      [
        { transform: 'translate(0, 0)' },
        { transform: 'translate(-7px, 4px)' },
        { transform: 'translate(6px, -5px)' },
        { transform: 'translate(-5px, -3px)' },
        { transform: 'translate(4px, 4px)' },
        { transform: 'translate(-2px, 1px)' },
        { transform: 'translate(0, 0)' },
      ],
      { duration: 450, easing: 'ease-out' },
    )

    return () => animation.cancel()
  }
